import React from 'react';

// Identidad visual del local (pedido de Mica, 2026-10-09): colores plenos,
// nunca degradé. Se usa en el login, en el encabezado de todas las pantallas
// de gestión y en la comunidad.
export const COLORES_MARCA = {
  rojo: '#E4212C',
  azul: '#2850A0',
  amarillo: '#FAC81E',
};

// Franja de tres bloques plenos: rojo, azul y amarillo.
function FranjaMarca({ alto = 6 }) {
  return (
    <div style={{ display: 'flex', height: `${alto}px`, width: '100%' }}>
      <div style={{ flex: 1, background: COLORES_MARCA.rojo }} />
      <div style={{ flex: 1, background: COLORES_MARCA.azul }} />
      <div style={{ flex: 1, background: COLORES_MARCA.amarillo }} />
    </div>
  );
}

export default FranjaMarca;
